import { createRouter, createWebHistory } from 'vue-router';
// 导入主界面组件
import HomeView from '@/views/HomeView.vue';
// 确保详情页组件路径正确（根据实际文件名修改）
import CustomersViews from '@/views/CustomersViews.vue';
import CustomersViewsDetail from '@/views/CustomersViewsDetail.vue';
import MerchandisesViews from '@/views/MerchandisesViews.vue';
import MerchandisesViewsDetail from '@/views/MerchandisesViewsDetail.vue';
import OrdersListView from '@/views/OrdersListView.vue';
import CreateOrderView from '@/views/CreateOrderView.vue';
import OrderDetailView from '@/views/OrderDetailView.vue';
import StatisticsView from '@/views/StatisticsView.vue'

const routes = [
    {
        path: '/',
        name: 'HomeView',
        component: HomeView
    },
    {
        path: '/home',
        redirect: '/',
    },
    {
        path: '/customers',
        name: 'CustomersViews',
        component: CustomersViews
    },
    {
        path: '/customers/detail/:id',
        name: 'CustomersViewsDetail',
        component: CustomersViewsDetail,
        props: true
    },
    {
        path: '/merchandises',
        name: 'MerchandisesViews',
        component: MerchandisesViews,
    },
    {
        path: '/merchandises/detail/:id',
        name: 'MerchandisesViewsDetail',
        component: MerchandisesViewsDetail,
        props: true
    },
    {
        path: '/orders',
        name: 'OrdersListView',
        component: OrdersListView
    },
    {
        path: '/orders/create',
        name: 'CreateOrderView',
        component: CreateOrderView
    },
    {
        path: '/orders/detail/:id',
        name: 'OrderDetailView',
        component: OrderDetailView,
        props: true
    },
    {
        path: '/statistics',
        name: 'StatisticsView',
        component: StatisticsView
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;